import React, { useState, useEffect } from "react";
import Select from "react-select";
import {Search} from 'lucide-react';
import classes from "./PendingAccount.module.css"
import plus from "../../../Assets/plus.svg"
import EyeIcon from "../../../Assets/new-eye.svg"
import DeleteIcon from "../../../Assets/new-delete.svg"
import PencilIcon from "../../../Assets/pencil.svg"

import { Spinner, Badge, Button, Modal, Form, Row, Col, Container, Table, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { CalendarX, CalendarCheck } from "lucide-react";


import axios from 'axios';
import Swal from 'sweetalert2';
import HeaderNav from '../../Budget/Budget Dashboard/HeaderNav/HeaderNav';
import RotatingLogo from '../../../Assets/rotating-logo.png';
import { FaTrash, FaPlus } from "react-icons/fa";  
import download from "../../../Assets/download1.svg"

import { BASE_URL } from "../../../Components/Styles/API/API";
import { useNavigate } from "react-router-dom";
import Skeleton from "react-loading-skeleton";


const PendingAccount = () => {
    const [selectedOption, setSelectedOption] = useState(null);
    const [searchTerm,setSearchTerm] = useState("");
    const [show, setShow] = useState(false);
    const [loanCode, setLoanCode] = useState("");
  const [loanDescription, setLoanDescription] = useState("");
  const [selectedReportTo, setSelectedReportTo] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [suppliers, setSuppliers] = useState([]);
  const [show1, setShow1] = useState(false);
  const [uploadShow, setUploadShow] = useState(false);
  const [file, setFile] = useState(null);
  const [bearer, setBearer] = useState('');
  const [uploadLoading, setUploadLoading] = useState(false);
  const [bankName, setBankName] = useState('');
  const [bankName1, setBankName1] = useState('');
  const [accName, setAccName] = useState('');
  const [accName1, setAccName1] = useState('');
  const [accNo, setAccNo] = useState('');
  const [accNo1, setAccNo1] = useState('');
  const [fullName, setFullName] = useState("");
  const [fullName1, setFullName1] = useState();
  const [email, setEmail] = useState("");
  const [email1, setEmail1] = useState();
  const [address, setAddress] = useState([]);
  const [address1, setAddress1] = useState();
  const [phone, setPhone] = useState();
  const [phoneNo, setPhoneNo] = useState("");
  const [loading, setLoading] = useState(false);
  const [user, setUser] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [selectAll, setSelectAll] = useState(false);
  // const [totalPages, setTotalPages] = useState(1);
  // const [totalEntries, setTotalEntries] = useState("");
  const [tableData, setTableData] = useState([]);
  const [tableData2, setTableData2] = useState([]);
  const navigate = useNavigate();
  const [benLoading, setBenLoading] = useState(false);
  const [error, setError] = useState(null);
  const [entriesPerPage, setEntriesPerPage] = useState(100);
  const [selectedItems, setSelectedItems] = useState([]);
  const [selectedItemId, setSelectedItemId] = useState(null);
  const [description, setDescription] = useState('');
  const [approveLoading, setApproveLoading] = useState(false);
  const [disapproveLoading, setDisapproveLoading] = useState(false);

  
  const readData = async () => {
    try {
      const value = await localStorage.getItem('userToken');
      const value1 = await localStorage.getItem('tobi');

      if (value !== null) {
        setBearer(value);
      }
      if (value1 !== null) {
        setUser(value1);
      }
    } catch (e) {
      alert('Failed to fetch the input from storage');
    }
  };

  useEffect(() => {
    readData();
  }, []);

  const headers = {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${bearer}`
  };

  

  const handleClose1 = () => setShow1(false);

const handleShow1 = (item) => {
  setSuppliers(item)
  setFullName1(item.name || "");
  setEmail1(item.email || "");
  setAddress1(item.address || "");
  setPhoneNo(item.phone_number || "");
  setShow1(true);
};

// const FetchSuppliers = async () => {
//   setBenLoading(true);
//   try {
//     const response = await axios.get(`${BASE_URL}/beneficiary`, { headers });
//     const results = response.data?.data;
//     const resultx = response.data?.data?.total;

//     setTableData(results);
//     const total = response.data?.data?.last_page || 1;
  

//   } catch (error) {
//     if (error.response && error.response.status === 401) {
//       navigate('/login');
//     } else {
//       let errorMessage = 'An error occurred. Please try again.';
//       if (error.response && error.response.data && error.response.data.message) {
//         if (typeof error.response.data.message === 'string') {
//           errorMessage = error.response.data.message;
//         } else if (Array.isArray(error.response.data.message)) {
//           errorMessage = error.response.data.message.join('; ');
//         } else if (typeof error.response.data.message === 'object') {
//           console.log(errorMessage);
//           setError(errorMessage)
//         }
//       }
//       setTableData([]);
//     }
//   } finally {
//     setBenLoading(false);
//   }

// };


useEffect(() => {
  if (bearer) {
    // FetchSuppliers();
  }
}, [bearer, currentPage]);

const fetchData = async () => {
  setIsLoading(true);
  try {
    const response = await axios.get(`${BASE_URL}/account/all-pending`, { headers });
    const subCat = response.data?.data;
    setTableData2(subCat);
  } catch (error) {
    if (error.response && error.response.status === 401) {
      // Redirect to login page if unauthorized
      navigate('/login');
    } else {
      const errorStatus = error.response?.data?.message;
      console.log(errorStatus);
      setTableData2([]);
    }
  } finally {
    setIsLoading(false);
  }
};



useEffect(() => {
  if (bearer) {
    // fetchData();
    fetchData();
  }
}, [bearer]);


const handleCheckboxChange = (id) => {
  if (selectedItems.includes(id)) {
    setSelectedItems(selectedItems.filter(itemId => itemId !== id));
  } else {
    setSelectedItems([...selectedItems, id]);
  }
};


const handleShow = (id) => {
  setSelectedItemId(id);
  setShow(true);
};

const handleClose = () => {
  setShow(false);
  setDescription(''); // Clear the description on close
};

const handleApprove = async (id) => {
  const confirmed = await Swal.fire({
    title: 'Are you sure?',
    text: `You are about to approve this`,
    icon: 'warning',
    showCancelButton: true,
    confirmButtonColor: '#3085d6',
    cancelButtonColor: '#d33',
    confirmButtonText: 'Yes, Approve it!',
    cancelButtonText: 'No, Cancel',
  });

  if (!confirmed.isConfirmed) {
    return; // User canceled, do nothing
  }

  // Show a Swal saying "Changing the working month, please wait..." and prevent interaction
  Swal.fire({
    title: 'Approving...',
    text: 'Please wait while your request is being processed.',
    icon: 'info',
    allowOutsideClick: false,
    showConfirmButton: false, // Hide the confirm button
    didOpen: () => {
      Swal.showLoading(); // Show loading spinner
    }
  });
  setApproveLoading(true);
  try {
    const response = await axios.post(
      `${BASE_URL}/account/approve`,
      {
        id: id,
      },
      {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${bearer}`,
        },
      }
    );

    // Display success message
    Swal.fire({
      icon: 'success',
      title: 'Success',
      text: response.data.message,
    });
    fetchData();
    console.log(response.data);
  } catch (error) {
    let errorMessage = 'An error occurred. Please try again.';
    if (error.response && error.response.data && error.response.data.message) {
      if (typeof error.response.data.message === 'string') {
        errorMessage = error.response.data.message;
      } else if (Array.isArray(error.response.data.message)) {
        errorMessage = error.response.data.message.join('; ');
      } else if (typeof error.response.data.message === 'object') {
        errorMessage = JSON.stringify(error.response.data.message);
      }
    }
    Swal.fire({
      icon: 'error',
      title: 'Failed',
      text: errorMessage,
    });
    console.log(error);
  } finally {
    setApproveLoading(false);
  }
};

const handleUploadShow = () => setUploadShow(true);

 //delete function
 const handleTrashClick = async (id) => {
  const confirmed = await Swal.fire({
    title: 'Are you sure?',
    text: 'You are about to delete this account.',
    icon: 'warning',
    showCancelButton: true,
    confirmButtonColor: '#3085d6',
    cancelButtonColor: '#d33',
    confirmButtonText: 'Yes, delete it!',
    cancelButtonText: 'No, cancel',
  });

  if (!confirmed.isConfirmed) {
    return; // User canceled, do nothing
  }
  setUploadLoading(true);

  try {
    const response = await axios.get(`${BASE_URL}/provinces/delete-province-pending-account?id=${id}`, { headers });
    fetchData();
    Swal.fire({
      icon: 'success',
      title: 'Success',
      text: response.data.message,
    });
    setUploadLoading(false);
  } catch (error) {
    let errorMessage = 'An error occurred. Please try again.';
    if (error.response && error.response.data && error.response.data.message) {
      if (typeof error.response.data.message === 'string') {
        errorMessage = error.response.data.message;
      } else if (Array.isArray(error.response.data.message)) {
        errorMessage = error.response.data.message.join('; ');
      } else if (typeof error.response.data.message === 'object') {
        errorMessage = JSON.stringify(error.response.data.message);
      }
      // toast.error(errorMessage)
      console.log(errorMessage);
      Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: errorMessage,
      });
    }
  }
  finally {
    setUploadLoading(false); // always stop uploading, success or fail
  }
};

const handleDisApprove = async () => {
  const confirmed = await Swal.fire({
    title: 'Are you sure?',
    text: `You are about to disapprove this`,
    icon: 'warning',
    showCancelButton: true,
    confirmButtonColor: '#3085d6',
    cancelButtonColor: '#d33',
    confirmButtonText: 'Yes, Yes, Disapprove it!',
    cancelButtonText: 'No, Cancel',
  });

  if (!confirmed.isConfirmed) {
    return; // User canceled, do nothing
  }

  // Show a Swal saying "Changing the working month, please wait..." and prevent interaction
  Swal.fire({
    title: 'Disapproving...',
    text: 'Please wait while your request is being processed.',
    icon: 'info',
    allowOutsideClick: false,
    showConfirmButton: false, // Hide the confirm button
    didOpen: () => {
      Swal.showLoading(); // Show loading spinner
    }
  });
  setDisapproveLoading(true);
  try {
    const response = await axios.post(
      `${BASE_URL}/account/disapprove`,
      {
        id: selectedItemId,
        description: description
      },
      {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${bearer}`,
        },
      }
    );

    // Display success message
    Swal.fire({
      icon: 'success',
      title: 'Success',
      text: response.data.message,
    }).then(() => {
      window.location.reload();
    });

    console.log(response.data);

  } catch (error) {
    let errorMessage = 'An error occurred. Please try again.';
    if (error.response && error.response.data && error.response.data.message) {
      if (typeof error.response.data.message === 'string') {
        errorMessage = error.response.data.message;
      } else if (Array.isArray(error.response.data.message)) {
        errorMessage = error.response.data.message.join('; ');
      } else if (typeof error.response.data.message === 'object') {
        errorMessage = JSON.stringify(error.response.data.message);
      }
    }
    Swal.fire({
      icon: 'error',
      title: 'Failed',
      text: errorMessage,
    });
    console.log(error);
  } finally {
    setDisapproveLoading(false);
  }
};

const filteredData = tableData2.filter(item => item.gl_name.toLowerCase().includes(searchTerm.toLowerCase()));

const totalPages = Math.ceil(filteredData.length / entriesPerPage);
const totalEntries = filteredData.length;
const startIndexx = (currentPage - 1) * entriesPerPage + 1;
const endIndexx = Math.min(startIndexx + entriesPerPage - 1, totalEntries);
const displayedData = filteredData.slice(startIndexx - 1, endIndexx);
const formattedTotalEntries = totalEntries.toLocaleString();

const handlePrevPage = () => {
  setCurrentPage(prevPage => Math.max(prevPage - 1, 1));
};

const handleNextPage = () => {
  setCurrentPage(prevPage => Math.min(prevPage + 1, totalPages));
};

 // Handle "Select All" checkbox toggle
 const handleSelectAll = () => {
  if (selectAll) {
    setSelectedItems([]); // Deselect all
  } else {
    const allIds = [...displayedData, ...tableData].map(item => item.id);
    setSelectedItems(allIds); // Select all
  }
  setSelectAll(!selectAll);
};

// Determine if the item is selected
const isSelected = (id) => selectedItems.includes(id);

function formatDate(dateString) {
  const date = new Date(dateString);
  const formattedDate = `${date.getFullYear()}-${padZero(date.getMonth() + 1)}-${padZero(date.getDate())} ${padZero(date.getHours())}:${padZero(date.getMinutes())} ${date.getHours() >= 12 ? 'PM' : 'AM'}`;
  return formattedDate;
}

function padZero(num) {
  return num < 10 ? `0${num}` : num;
}
        
  return (
    <div >
        <HeaderNav />

        <Modal show={show} onHide={handleClose} animation={false}>
              <Modal.Header closeButton>
                <Modal.Title>Reason for Disapproving</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <Form>
                  <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                    <Form.Label>Description</Form.Label>
                    <textarea
                      className="form-control"
                      rows="3"
                      cols="50"
                      placeholder="Enter reason here..."
                      value={description}
                      onChange={(e) => setDescription(e.target.value)}
                    />
                  </Form.Group>
                </Form>
              </Modal.Body>
              <Modal.Footer>
                <Button variant="danger" onClick={handleClose}>
                  Cancel
                </Button>
                <button className={classes.loanBtn} onClick={handleDisApprove}>
                    Disapprove
                </button>
              </Modal.Footer>
            </Modal>

        {loading && (
                <div className={classes.overlay}>
                  <img src={RotatingLogo} alt="Loading..." className={classes.rotatingLogo} />
                </div>
                )}


        <div className={classes.topContainer}>
          <div className={classes.topNavBars}>
            <Button className={classes.buttonsNav}>Approval</Button>
            <Button className={classes.buttonsNav}>Administration</Button>
            <Button className={classes.buttonsNav}>Financial Statements</Button>
            <Button className={classes.buttonsNav}>Report</Button>
          </div>
          <div style={{}}/>
            <h3 className={classes.topText}>Account Approval</h3>
            <p className={classes.prgText}>Approve and Disapprove Account</p>
            <div className={classes.subContainer}>
               
                           
                            <div style={{marginLeft: "6px", display: "flex", gap: "20px"}}>
                            {/* <button className={classes.loanBtn} 
                           
                            onClick={handleShow}
                            >
                              <img src={plus} alt="plus" /> 
                              Add New
                            </button> */}

                            {/* <button className={classes.loanBtn} 
                          onClick={handleUploadShow}
                          >
                            Upload Excel
                          </button> */}

                            {/* <button  className={classes.customButton1} >
                            <a href="https://account-api.patna.ng/api/v1/download_suppliers_template" download>
                            <img src={download} alt="download" /> Download Template
                              </a>
                          </button>  */}
                          </div>

                          {/* <div className={classes.statCount}>
                              <div className={classes.statConn}>
                              <p className={classes.txtHd}>Suppliers Accounts</p>
                              <p className={classes.txtHds}>{formattedTotalEntries}</p>
                              </div>
                            </div> */}

                         {/* <div className={classes.searchInputWrapper}>
                                <input
                                    type="text"
                                    value={searchTerm}
                                    onChange={(e) => setSearchTerm(e.target.value)}
                                    className={classes.searchInput}
                                    placeholder="Search accounts..."
                                />
                                <Search className={classes.searchIcon} size={16} />
                            </div> */}

            </div>
            
            <div className={classes.tableContainer}>
            
          <table className={classes.tableTable}>
          <thead className={classes.tableHeader} style={{ whiteSpace: 'nowrap' }}>
                        <tr>
                        <th>
                  <input
                    type="checkbox"
                    checked={selectAll}
                    onChange={handleSelectAll}
                  />
                </th>
                          <th>#</th>
                          <th>Account Code</th>
                          <th>Account Name</th>
                          <th >Account Type</th>
                          <th >Category</th>
                          <th >Sub Category</th>
                          <th >Created By</th>
                          <th >Created Date</th>
                          <th>Directions</th>
                          <th>Actions</th>
                        </tr>
                      </thead>
  {/* <tbody>

  { benLoading ? (
    searchTerm ? (
      <tr>
        <td colSpan={5} style={{ textAlign: "center" }}>
          Fetching Suppliers...
        </td>
      </tr>
    ) : (
      Array(5).fill().map((_, idx) => (
        <tr key={idx}>
          {Array(5).fill().map((_, i) => (
            <td key={i}>
              <Skeleton height={20} style={{ marginBottom: 10 }} />
            </td>
          ))}
        </tr>
      ))
    )
  ) : (
    displayedData.map((item, index) => (
      <tr key={index}>
        <td className={classes.textby}>{index + 1}</td>
        <td className={classes.textby}>{item.name}</td>
        <td className={classes.textby}>{item.email}</td>
        <td className={classes.textby}>{item.phone_number}</td>
        <td className={classes.btnAction}>
          <button
            style={{ backgroundColor: "transparent", border: 0, cursor: "pointer" }}
            onClick={() => handleShow1(item)}
          >
            <img src={EyeIcon} />
          </button>

          <button
            onClick={() => handleTrashClick(item.id)}
            style={{ backgroundColor: "transparent", border: 0, cursor: "pointer" }}
          >
            <img src={DeleteIcon} />
          </button>
        </td>
      </tr>
    ))
  )
}
  </tbody> */}

  <tbody style={{ whiteSpace: 'nowrap' }}>
                        {(displayedData.length === 0 && tableData.length === 0) ? (
                          <tr>
                            <td colSpan="11" style={{ textAlign: "center" }}>No data available</td>
                          </tr>
                        ) : (
                          <>
                            {displayedData.map((item, index) => (
                              <tr key={index}>
                                 <td style={{paddingLeft: "12px"}}>
                        <input 
                          type="checkbox"
                          checked={isSelected(item.id)}
                          onChange={() => handleCheckboxChange(item.id)}
                        />
                      </td>
                                <td className={classes.textby} style={{ width: 20 }}>{index + 1}</td>
                                <td className={classes.textby}>{item.gl_code}</td>
                                <td className={classes.textby} style={{paddingLeft: "15px",  whiteSpace: "nowrap" }}>{item.gl_name}</td>
                                <td className={classes.textby} style={{  paddingLeft: "20px" }}>{item.class?.description}</td>
                                <td className={classes.textby} style={{  whiteSpace: "wrap", paddingLeft: "25px" }}>{item.category?.description}</td>
                                <td className={classes.textby} style={{ paddingLeft: "18px",  whiteSpace: "wrap" }}>{item.subcategory?.description}</td>
                                <td className={classes.textby} style={{ textAlign: "left",  whiteSpace: "nowrap" }}>{item.created_by?.name}</td>
                                <td className={classes.textby} style={{ textAlign: "left", whiteSpace: "nowrap" }}>{formatDate(item.created_at)}</td>
                                <td className={classes.textby} style={{ paddingLeft: "30px",  whiteSpace: "nowrap" }}>{item.direction === "1" ? "DR" : "CR"}</td>
                                <td style={{ padding: 5 }}>
                                  {item.status !== '1' && item.status !== '2' && (
                                    <>
                                      <OverlayTrigger
                                        placement="top"
                                        overlay={<Tooltip id="button-tooltip">Click to approve this account</Tooltip>}
                                      >
                                        <CalendarCheck size={16} color="#2d995f" style={{ cursor: "pointer" }} onClick={() => handleApprove(item.id)} />
                                      </OverlayTrigger>
                                      <OverlayTrigger
                                        placement="top"
                                        overlay={<Tooltip id="button-tooltip">Click to disapprove this account</Tooltip>}
                                      >
                                      <CalendarX size={16} color="#dc3545" 
                                      style={{ cursor: "pointer", marginLeft: 10 }} 
                                      onClick={() => handleShow(item.id)} />
                                      </OverlayTrigger>
                                      <OverlayTrigger
                                        placement="top"
                                        overlay={<Tooltip id="button-tooltip">Click to delete this account</Tooltip>}
                                      >
                                      <div onClick={() => handleTrashClick(item.id)} className="btn btn-danger-soft btn-sm">
                                          <img src={DeleteIcon} />
                                          </div>
                                      </OverlayTrigger>
                                    </>
                                  )}
                                </td>
                              </tr>
                            ))}
                            {tableData.map((item, index) => (
                              <tr key={index}>
                                <td className={classes.textby} style={{ width: 20 }}>{index + 1}</td>
                                <td className={classes.textby} >{item.gl_code}</td>
                                <td className={classes.textby} style={{ textAlign: "left", whiteSpace: "wrap", width: 300 }}>{item.gl_name}</td>
                                <td className={classes.textby} style={{ width: 60, whiteSpace: "wrap" }}>{item.class?.description}</td>
                                <td className={classes.textby} style={{ width: 120, whiteSpace: "wrap" }}>{item.category?.description}</td>
                                <td className={classes.textby} style={{ textAlign: "left", width: 200, whiteSpace: "wrap" }}>{item.subcategory?.description}</td>
                                <td className={classes.textby} style={{ textAlign: "left", width: 200, whiteSpace: "wrap" }}>{item.created_by?.name}</td>
                                <td className={classes.textby} style={{ textAlign: "left", width: 200, whiteSpace: "wrap" }}>{formatDate(item.created_at)}</td>
                                <td className={classes.textby} style={{ textAlign: "left", width: 60, whiteSpace: "wrap" }}>{item.direction === "1" ? "DR" : "CR"}</td>
                                <td style={{ padding: 5 }}>
                                  {item.status !== '1' && item.status !== '2' && (
                                    <>
                                      <OverlayTrigger
                                        placement="top"
                                        overlay={<Tooltip id="button-tooltip">Click to delete this account</Tooltip>}
                                      >
                                       <CalendarCheck size={22} color="#2d995f" style={{ cursor: "pointer" }} onClick={() => handleApprove(item.id)} />
                                        {/* <FaCalendarCheck onClick={() => handleApprove(item.id)} style={{ height: 22, color: "#2d995f", cursor: 'pointer' }} /> */}
                                      </OverlayTrigger>
                                      <OverlayTrigger
                                        placement="top"
                                        overlay={<Tooltip id="button-tooltip">Click to disapprove this account</Tooltip>}
                                      >
                                       <CalendarX size={22} color="#dc3545" 
                                      style={{ cursor: "pointer", marginLeft: 10 }} 
                                      onClick={() => handleShow(item.id)} />
                                        {/* <FaCalendarXmark style={{ height: 22, color: "#dc3545", cursor: 'pointer', marginLeft: 10 }} onClick={() => handleShow(item.id)} /> */}
                                      </OverlayTrigger>
                                      <OverlayTrigger
                                        placement="top"
                                        overlay={<Tooltip id="button-tooltip">Click to delete this account</Tooltip>}
                                      >
                                      <div onClick={() => handleTrashClick(item.id)} className="btn btn-danger-soft btn-sm">
                                          {/* <i className="far fa-trash-alt"  style={{color: "#dc3545", backgroundColor: "#dc35451a", padding: 2, borderColor: "#dc35454d", borderRadius: 5, fontSize:12}}></i> */}
                                          <img src={DeleteIcon} />
                                          </div>
                                      </OverlayTrigger>
                                    </>
                                  )}
                                </td>
                              </tr>
                            ))}
                          </>
                        )}
                      </tbody>

  




</table>

{!benLoading && (
            <div className={classes.paginationStyle}>
              <div className={classes.footerSubOne}>
                <button onClick={handlePrevPage}
                  disabled={currentPage === 1} className={classes.btnFirst}>Prev</button>
                {[...Array(totalPages)].map((_, page) => {
                  // Show only 5 pages or less if available
                  if (page < 5 || page === currentPage - 1 || page === totalPages - 1) {
                    return (
                      <span key={page + 1} className={classes.ftOne}>
                        <button
                          className={`${classes.pageNumber} ${currentPage === page + 1 ? classes.active : ""}`}
                          onClick={() => setCurrentPage(page + 1)}
                        >
                          {page + 1}
                        </button>
                      </span>
                    );
                  }
                })}


                <button className={classes.btnSec} onClick={handleNextPage}
                  disabled={currentPage === totalPages}>Next</button>
              </div>
              <p className={classes.displayPag}>Displaying {`Page ${currentPage} - ${totalPages} pages`} of {formattedTotalEntries} entries</p>
            </div>
          )}



            </div>
        </div>
    </div>
  )
}

export default PendingAccount